export default {

  initChat () { 
    window.customerly.open();
  }

}